export default async function sendMessageToTelegram(
  userId: string,
  message: string,
) {
  try {
    const response = await fetch('/api/telegram/sendmessage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        message,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Ошибка при отправке сообщения:', errorData.message);
    } else {
      // console.log('Сообщение успешно отправлено');
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
  }
}
